import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate login process
    setTimeout(() => {
      setIsLoading(false);
      navigate('/');
    }, 1500);
  };
  const handleLinkedInLogin = () => {
    setIsLoading(true);
    // Simulate LinkedIn login process
    setTimeout(() => {
      setIsLoading(false);
      navigate('/'); // This already routes to the Formazione section
    }, 1500);
  };
  return <div className="min-h-screen bg-black flex flex-col justify-center" data-id="element-1803">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-1804">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kYK3VqJh5ErppvW42Sa6wk/IMG_1178.png" alt="EIIS Logo" className="h-16 mx-auto" data-id="element-1805" />
        <h2 className="mt-6 text-center text-2xl font-bold text-white" data-id="element-1806">
          Accedi al tuo account
        </h2>
        <p className="mt-2 text-center text-sm text-gray-400" data-id="element-1807">
          Accedi alla piattaforma EIIS per continuare il tuo percorso formativo
        </p>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-1808">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" data-id="element-1809">
          <form className="space-y-6" onSubmit={handleLogin} data-id="element-1810">
            <div data-id="element-1811">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-1812">
                Email
              </label>
              <div className="mt-1" data-id="element-1813">
                <input id="email" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-custom-green focus:border-custom-green sm:text-sm" placeholder="nome@esempio.it" data-id="element-1814" />
              </div>
            </div>
            <div data-id="element-1815">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-1816">
                Password
              </label>
              <div className="mt-1 relative" data-id="element-1817">
                <input id="password" name="password" type={showPassword ? 'text' : 'password'} autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-custom-green focus:border-custom-green sm:text-sm" placeholder="••••••••" data-id="element-1818" />
                <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center" onClick={() => setShowPassword(!showPassword)} data-id="element-1819">
                  {showPassword ? <EyeOffIcon className="h-5 w-5 text-gray-400" data-id="element-1820" /> : <EyeIcon className="h-5 w-5 text-gray-400" data-id="element-1821" />}
                </button>
              </div>
            </div>
            <div className="flex items-center justify-between" data-id="element-1822">
              <div className="flex items-center" data-id="element-1823">
                <input id="remember-me" name="remember-me" type="checkbox" checked={rememberMe} onChange={e => setRememberMe(e.target.checked)} className="h-4 w-4 text-custom-green focus:ring-custom-green border-gray-300 rounded" data-id="element-1824" />
                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700" data-id="element-1825">
                  Ricordami
                </label>
              </div>
              <div className="text-sm" data-id="element-1826">
                <a href="#" className="font-medium text-custom-green hover:text-custom-green/80" data-id="element-1827">
                  Password dimenticata?
                </a>
              </div>
            </div>
            <div data-id="element-1828">
              <button type="submit" disabled={isLoading} className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-custom-green hover:bg-custom-green/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-custom-green disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-1829">
                {isLoading ? 'Accesso in corso...' : 'Accedi'}
              </button>
            </div>
          </form>
          <div className="mt-6" data-id="element-1830">
            <div className="relative" data-id="element-1831">
              <div className="absolute inset-0 flex items-center" data-id="element-1832">
                <div className="w-full border-t border-gray-300" data-id="element-1833"></div>
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-1834">
                <span className="px-2 bg-white text-gray-500" data-id="element-1835">
                  Oppure continua con
                </span>
              </div>
            </div>
            <div className="mt-6" data-id="element-1836">
              <button onClick={handleLinkedInLogin} disabled={isLoading} className="w-full flex justify-center items-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#0A66C2] hover:bg-[#0A66C2]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0A66C2] disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-1837">
                LinkedIn
              </button>
            </div>
          </div>
          <div className="mt-6" data-id="element-1838">
            <p className="text-center text-xs text-gray-500" data-id="element-1839">
              Non hai un account?{' '}
              <Link to="/register" className="font-medium text-custom-green hover:text-custom-green/80" data-id="element-1840">
                Registrati
              </Link>
            </p>
          </div>
        </div>
      </div>
      <footer className="mt-8 text-center text-xs text-gray-400" data-id="element-1841">
        <p data-id="element-1842">
          © 2023 EIIS - European Institute for Innovation and Sustainability
        </p>
        <p className="mt-1" data-id="element-1843">
          <a href="#" className="text-custom-green hover:text-custom-green/80" data-id="element-1844">
            Privacy Policy
          </a>{' '}
          ·
          <a href="#" className="text-custom-green hover:text-custom-green/80 ml-2" data-id="element-1845">
            Termini di Servizio
          </a>
        </p>
      </footer>
    </div>;
};
export default Login;